import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';

export const QuietHoursWarning = () => {
  return (
    <Alert variant="destructive" className="mt-4">
      <AlertCircle className="h-4 w-4" />
      <AlertDescription>
        {`Your SMS is scheduled during quiet hours (8pm - 9am). To align with FTC rules and regulations, this message
          won't be sent until 9am the following morning.`}
      </AlertDescription>
    </Alert>
  );
};
